export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "en",
    "resource": {
      "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show/hide Tooltip Information"])},
      "tooltipLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Info Tooltip"])}
    }
  })
}
